import { useMemo } from "react";

import { getCoreRowModel, getSortedRowModel, useReactTable } from "@tanstack/react-table";

import { useGrid } from "@Components/Grid/context";

export function useGridTable() {
  const { columns, store: { collections: { items } }, state: { sorting, setSorting } } = useGrid()

  return useReactTable({
    manualSorting: true,
    data: items,
    columns,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    state: { sorting },
    onSortingChange: setSorting,
  })
}

export function useTableProps({ margins }) {
  return useMemo(() => {
    const containerClassName = margins ? '' : 'content-marginless'

    return {
      containerClassName,
    }
  }, [margins])
}
